var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.btnTitle)},on:{"click":_vm._click}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c04a9852","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitleButton.vue
// module id = null
// module chunks = 